import React from 'react';
import {
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Paper,
  TablePagination
} from '@mui/material';
import { Container } from './styles';
import getRow from './Row';
import getRowReporting from './RowReporting';
import getRowDataQuality from  './RowDataQuality';
import getRowImpact from  './RowImpact';
import PropTypes from 'prop-types';

const DetailsTable = ({ rows, headers, onClickHeader, type }) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [allRows, setAllRows] = React.useState([...rows]);
  const [selectedSubRow, setSelectedSubRow] = React.useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSelectedSubRow = subrow => {
    setSelectedSubRow(subrow);
  };

  const handleClickOpenCloseIR = () => {
    window.open('impact-receipt', '_blank');
  };

  const handleOpenRow = row => {
    const newRows = [...allRows].map(existingRow => {
      if (existingRow.npo === row.npo) {
        existingRow.open = !existingRow.open;
      } else {
        existingRow.open = false;
      }
      return existingRow;
    });
    setAllRows(newRows);
  };

  const slicedRows = allRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleGetRow = (props) => {
    switch (type) {
      case 'REPORTING':
        return getRowReporting(props);
      case 'DATA_QUALITY':
        return getRowDataQuality(props);
        case 'IMPACT':
          return getRowImpact(props);
      default:
        return getRow(props);
    }
  };

  return (
    <Container>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              {headers.map(head => (
                <TableCell
                  style={{ padding: 5 }}
                  key={head}
                  onClick={() => onClickHeader(head)}
                >
                  {head}
                </TableCell>
              ))}
              <TableCell style={{ paddingLeft: 15 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {slicedRows.map(row =>
              handleGetRow({
                handleClickOpenCloseIR,
                row,
                setSelectedSubRow,
                selectedSubRow,
                handleOpenRow,
                handleSelectedSubRow
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25]}
        count={allRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Container>
  );
};

DetailsTable.propTypes = {
  rows: PropTypes.object,
  headers: PropTypes.object,
  onClickHeader: PropTypes.func,
  type: PropTypes.object,
};

export default DetailsTable;
